import * as React from 'react';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
import qs from 'qs';
import { ButtonLink } from '../../components/Button';
import { paths } from '../../paths';
import { useIntendedPath } from '../../hooks/useIntendedPath';

export const SignUpPrompt: React.FC = ({}) => {
  const intendedQueryString = pipe(
    useIntendedPath(),
    O.map((intended) => qs.stringify({ intended }, { addQueryPrefix: true })),
    O.getOrElse(() => ''),
  );

  return (
    <div className="text-grey-800 sm:flex sm:items-center sm:justify-center space-y-4 sm:space-y-0 sm:space-x-4 w-full max-w-sm mx-auto">
      <p>Don't have an account?</p>
      <div className="block sm:inline-block">
        <ButtonLink
          to={{ pathname: paths.register(), search: intendedQueryString }}
          kind="plain"
        >
          Sign up
        </ButtonLink>
      </div>
    </div>
  );
};
